import React from "react";
import { Link } from "react-router-dom";
import "../css/Contact.css";

function Contact() {
  return (
    <div>
      {/* Contact Section */}
      <section className="contact">
        <div className="container">
          <h4 className="contact-head">Contact Us</h4>
          <p className="contact-sub">
            Your child's education is our priority, and we're here to support
            you every step of the way. Reach out to us for any information on
            how our programs can help shape your child's success.
          </p>

          <div className="row">
            {/* First School Contact */}
            <div className="col-md-6">
              <div className="address-card">
                <h5 className="school">SMG Vidyamandir and Jr. College</h5>
                <p className="contact-para">
                  Diva-Agason Road, Dativali Road, Diva (E). Thane - 400612.
                </p>
                <p className="contact-para">
                  +91 9594930307 |
                  <Link className="email" to="mailto:smgthane@gmail.com">
                    smgthane@gmail.com
                  </Link>
                </p>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.249741296256!2d73.04430127498019!3d19.18429138204273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bfaea40abb55%3A0x3989bb3db13a06db!2sS.M.G%20Vidyamandir%20%26%20Junior%20College!5e0!3m2!1sen!2sin!4v1734038379394!5m2!1sen!2sin"
                className="map"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SMG Vidyamandir Location"
                aria-label="SMG Vidyamandir and Jr. College Location"
              ></iframe>
            </div>

            {/* Second School Contact */}
            <div className="col-md-6">
              <div className="address-card">
                <h5 className="school">SMG Vidyalay and Jr. College</h5>
                <p className="contact-para">
                  Sonarpada, Lalit kata Sonarpada Road, Dombivali (E),
                  Thane-421201.
                </p>
                <p className="contact-para">
                  +91 8976666266 |
                  <Link className="email" to="mailto:smgdombivali@gmail.com">
                    smgdombivali@gmail.com
                  </Link>
                </p>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1884.053602474678!2d73.09633318858158!3d19.190519395509476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7957098e07189%3A0x47b509334d6fb53b!2sSMG%20Vidyalay%20And%20Junior%20College!5e0!3m2!1sen!2sin!4v1734038441451!5m2!1sen!2sin"
                className="map"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SMG Vidyalay Location"
                aria-label="SMG Vidyalay and Jr. College Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
